import { ClientAnalytics } from './clientAnalytics'

// ── Install flow ──
type InstallEvent =
  | 'notebook:install:prompt_shown'
  | 'notebook:install:accepted'
  | 'notebook:install:phase_start'
  | 'notebook:install:phase_complete'
  | 'notebook:install:complete'
  | 'notebook:install:cache_reset'
  | 'notebook:install:stalled'

// ── Toolbar ──
type ToolbarEvent =
  | 'notebook:toolbar:run'
  | 'notebook:toolbar:run_all'
  | 'notebook:toolbar:stop'
  | 'notebook:toolbar:restart'
  | 'notebook:toolbar:add_cell'
  | 'notebook:toolbar:delete_cell'
  | 'notebook:toolbar:move_cell'
  | 'notebook:toolbar:cell_type_change'
  | 'notebook:toolbar:undo'
  | 'notebook:toolbar:redo'
  | 'notebook:toolbar:clear_outputs'
  | 'notebook:toolbar:save'

// ── DataBar ──
type DataEvent =
  | 'notebook:data:download_start'
  | 'notebook:data:download_complete'
  | 'notebook:data:download_error'
  | 'notebook:data:insert_reference'
  | 'notebook:data:cache_hit'

// ── Session ──
type SessionEvent =
  | 'notebook:session:start'

// ── Cell pill ──
type CellPillEvent =
  | 'notebook:cell:duplicate'
  | 'notebook:cell:customize_open'

export type NotebookAnalyticsEvent =
  | InstallEvent
  | ToolbarEvent
  | DataEvent
  | SessionEvent
  | CellPillEvent

export function trackNotebook(event: NotebookAnalyticsEvent, properties?: Record<string, unknown>) {
  ClientAnalytics.track(event, properties)
}
